// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upgrade-view {
  background-color: var(--color-elevated-canvas);
  border: solid 1px var(--color-elevated-border);
  color: var(--color-elevated-text);
  font-size: 1.6rem;
  margin: 2rem auto 0;
  max-width: 40rem;
  padding: 2rem 3rem;
  text-align: left;
}
.upgrade-view .upgrade-restart-button, .upgrade-view .upgrade-restart-button.confirm {
  color: var(--color-elevated-warn);
  font-size: 1.2rem;
  font-weight: normal;
  width: 14.5rem;
}
.upgrade-view .upgrade-actions {
  margin-top: 2rem;
  text-align: center;
}
.upgrade-view .help, .upgrade-view .extra {
  font-size: 1rem;
}
.upgrade-view .help-divider {
  border: solid 0.1rem var(--color-elevated-border);
  clear: both;
  margin: 0.5rem 0;
}
.upgrade-view .help-link-line {
  margin-bottom: 0.5rem;
}
.upgrade-view .help-link {
  text-decoration: underline;
}
.upgrade-view .help-link:hover {
  color: var(--color-elevated-text);
  cursor: pointer;
}
.upgrade-view .help.extra {
  clear: both;
  margin-top: 1rem;
}
.upgrade-view .legal-links {
  float: right;
  position: relative;
  top: 2rem;
  text-align: right;
  left: 3rem;
}
.upgrade-view .logo.qci {
  display: block;
  fill: var(--color-emphasis-text);
  height: 5rem;
  margin: 1rem auto 2rem;
  opacity: 1;
}
.upgrade-view .title {
  font-size: 1.5rem;
  font-weight: lighter;
  text-align: center;
}
.upgrade-view .title .elevated {
  font-size: 1.6rem;
  font-weight: normal;
  margin: 0 0.1rem;
}
.upgrade-view .title-upgrade-restart {
  color: var(--color-elevated-warn);
  font-size: 1.3rem;
  font-weight: normal;
}`, "",{"version":3,"sources":["webpack://./src/style/views/upgrade.scss"],"names":[],"mappings":"AAAA;EACE,8CAAA;EACA,8CAAA;EACA,iCAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AACF;AACE;EACE,iCAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AACJ;AACE;EACE,gBAAA;EACA,kBAAA;AACJ;AAEE;EACE,eAAA;AAAJ;AAGE;EACE,iDAAA;EACA,WAAA;EACA,gBAAA;AADJ;AAIE;EACE,qBAAA;AAFJ;AAKE;EACE,0BAAA;AAHJ;AAII;EACE,iCAAA;EACA,eAAA;AAFN;AAME;EACE,WAAA;EACA,gBAAA;AAJJ;AAOE;EACE,YAAA;EACA,kBAAA;EAAoB,SAAA;EACpB,iBAAA;EACA,UAAA;AAJJ;AAOE;EACE,cAAA;EACA,gCAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;AALJ;AAQE;EACE,iBAAA;EACA,oBAAA;EACA,kBAAA;AANJ;AAQI;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;AANN;AAUE;EACE,iCAAA;EACA,iBAAA;EACA,mBAAA;AARJ","sourcesContent":[".upgrade-view {\n  background-color: var(--color-elevated-canvas);\n  border: solid 1px var(--color-elevated-border);\n  color: var(--color-elevated-text);\n  font-size: 1.6rem;\n  margin: 2rem auto 0;\n  max-width: 40rem;\n  padding: 2rem 3rem;\n  text-align: left;\n\n  .upgrade-restart-button, .upgrade-restart-button.confirm{\n    color: var(--color-elevated-warn);\n    font-size: 1.2rem;\n    font-weight: normal;\n    width: 14.5rem;\n  }\n  .upgrade-actions {\n    margin-top: 2rem;\n    text-align: center;\n  }\n\n  .help, .extra {\n    font-size: 1rem;\n  }\n\n  .help-divider {\n    border: solid 0.1rem var(--color-elevated-border);\n    clear: both;\n    margin: 0.5rem 0;\n  }\n\n  .help-link-line {\n    margin-bottom: 0.5rem;\n  }\n\n  .help-link {\n    text-decoration: underline;\n    &:hover {\n      color: var(--color-elevated-text);\n      cursor: pointer;\n    }\n  }\n\n  .help.extra {\n    clear: both;\n    margin-top: 1rem;\n  }\n\n  .legal-links {\n    float: right;\n    position: relative; top: 2rem;\n    text-align: right;\n    left: 3rem;\n  }\n\n  .logo.qci {\n    display: block;\n    fill: var(--color-emphasis-text);\n    height: 5rem;\n    margin: 1rem auto 2rem;;\n    opacity: 1;\n  }\n\n  .title {\n    font-size: 1.5rem;\n    font-weight: lighter;\n    text-align: center;\n\n    .elevated {\n      font-size: 1.6rem;\n      font-weight: normal;\n      margin: 0 0.1rem;\n    }\n  }\n\n  .title-upgrade-restart {\n    color: var(--color-elevated-warn);\n    font-size: 1.3rem;\n    font-weight: normal;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
